var _clipPath, _clipPath2, _clipPath3, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinbaseExchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 155,
    viewBox: "0 0 355 155",
    width: 355,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 155,
    rx: 16,
    width: 354.667,
    x: 0.333008
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34 26.3917c0-1.3209 1.0708-2.3917 2.3917-2.3917h282.2163c1.321 0 2.392 1.0708 2.392 2.3917v10.7625h-287z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.7627 59.875h221.229v118.387h-221.229z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    height: 199,
    maskUnits: "userSpaceOnUse",
    width: 371,
    x: 44,
    y: 59
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.7627 59.875h370v198h-370z",
    fill: "#c4c4c4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffd200",
    height: 155,
    rx: 16,
    width: 354.667,
    x: 0.333008
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34 26.0189c0-.7067 0-1.06.1375-1.3299.121-.2375.314-.4305.5515-.5515.2699-.1375.6232-.1375 1.3299-.1375h413.9061c.707 0 1.06 0 1.33.1375.237.121.43.314.551.5515.138.2699.138.6232.138 1.3299v10.5373h-417.944z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.9269,
    cy: 31.5225,
    fill: "#64c255",
    r: 1.89272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.9269,
    cy: 31.5225,
    r: 1.81385,
    stroke: "#000",
    strokeOpacity: 0.16,
    strokeWidth: 0.157726
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.6183,
    cy: 31.5225,
    fill: "#ffd171",
    r: 1.89272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.6183,
    cy: 31.5225,
    r: 1.81385,
    stroke: "#000",
    strokeOpacity: 0.16,
    strokeWidth: 0.157726
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.3087,
    cy: 31.5225,
    fill: "#ff796f",
    r: 1.89272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.3087,
    cy: 31.5225,
    r: 1.81385,
    stroke: "#000",
    strokeOpacity: 0.16,
    strokeWidth: 0.157726
  })), /*#__PURE__*/React.createElement("path", {
    d: "m34 36.5563h287v135.1287c0 2.642-2.142 4.784-4.783 4.784h-277.4337c-2.6417 0-4.7833-2.142-4.7833-4.784z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.078 115.185c0-.908.644-1.618 1.638-1.618 1.295 0 1.736 1.118 1.736 2.381 0 1.532-.625 2.44-1.809 2.44-.861 0-1.394-.467-1.473-1.105h.625c.033.322.309.605.848.605.816 0 1.184-.717 1.184-1.815v-.204h-.033c-.118.572-.611.881-1.197.881-.94 0-1.519-.658-1.519-1.565zm.625-.046v.079c0 .578.335 1.045 1.019 1.045.605 0 1.02-.453 1.02-1.045v-.079c0-.559-.395-1.072-1.026-1.072-.645 0-1.013.5-1.013 1.072zm5.2 4.143h-.553l.48-1.716h.625zm2.589-4.097c0-.908.644-1.618 1.638-1.618 1.295 0 1.736 1.118 1.736 2.381 0 1.532-.625 2.44-1.809 2.44-.861 0-1.394-.467-1.473-1.105h.625c.033.322.309.605.848.605.816 0 1.184-.717 1.184-1.815v-.204h-.033c-.118.572-.611.881-1.197.881-.94 0-1.519-.658-1.519-1.565zm.625-.046v.079c0 .578.335 1.045 1.019 1.045.605 0 1.02-.453 1.02-1.045v-.079c0-.559-.395-1.072-1.026-1.072-.645 0-1.013.5-1.013 1.072zm3.582.046c0-.908.644-1.618 1.638-1.618 1.295 0 1.736 1.118 1.736 2.381 0 1.532-.625 2.44-1.809 2.44-.861 0-1.394-.467-1.473-1.105h.625c.033.322.309.605.848.605.816 0 1.184-.717 1.184-1.815v-.204h-.033c-.118.572-.611.881-1.197.881-.94 0-1.519-.658-1.519-1.565zm.625-.046v.079c0 .578.335 1.045 1.019 1.045.605 0 1.02-.453 1.02-1.045v-.079c0-.559-.395-1.072-1.026-1.072-.645 0-1.013.5-1.013 1.072zm6.009.704v.026c.559.098.973.526.973 1.177 0 .776-.671 1.342-1.677 1.342s-1.677-.566-1.677-1.342c0-.651.414-1.079.973-1.177v-.026c-.526-.112-.861-.513-.861-1.027 0-.73.638-1.249 1.565-1.249s1.565.519 1.565 1.249c0 .514-.335.915-.861 1.027zm-1.664-1.02v.066c0 .414.394.75.96.75s.96-.336.96-.75v-.066c0-.434-.381-.756-.96-.756s-.96.322-.96.756zm-.099 2.131v.079c0 .493.415.862 1.059.862.645 0 1.059-.369 1.059-.862v-.079c0-.48-.408-.855-1.059-.855s-1.059.375-1.059.855zm5.266 1.401c-.263 0-.46-.204-.46-.46 0-.264.197-.467.46-.467s.461.203.461.467c0 .256-.198.46-.461.46zm4.207-4.788c1.046 0 1.684.697 1.684 1.828v1.151c0 1.158-.645 1.842-1.684 1.842-1.032 0-1.684-.684-1.684-1.842v-1.151c0-1.131.645-1.828 1.684-1.828zm0 4.275c.671 0 1.066-.493 1.066-1.296v-1.144c0-.789-.395-1.289-1.066-1.289s-1.065.5-1.065 1.289v1.144c0 .803.394 1.296 1.065 1.296zm4.207-4.275c1.046 0 1.684.697 1.684 1.828v1.151c0 1.158-.645 1.842-1.684 1.842-1.032 0-1.684-.684-1.684-1.842v-1.151c0-1.131.645-1.828 1.684-1.828zm0 4.275c.671 0 1.066-.493 1.066-1.296v-1.144c0-.789-.395-1.289-1.066-1.289s-1.065.5-1.065 1.289v1.144c0 .803.394 1.296 1.065 1.296z",
    fill: "#8a919e"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.597917
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.1963 116.079h230.7957",
    opacity: 0.5,
    stroke: "#5b616e",
    strokeDasharray: "1.2 2.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.1963 137.006h230.7957",
    opacity: 0.5,
    stroke: "#5b616e",
    strokeDasharray: "1.2 2.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.1963 95.1521h230.7957",
    opacity: 0.5,
    stroke: "#5b616e",
    strokeDasharray: "1.2 2.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.1963 73.6271h230.7957",
    opacity: 0.5,
    stroke: "#00d17f",
    strokeDasharray: "1.2 2.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.1963 51.5042h230.7957",
    opacity: 0.5,
    stroke: "#5b616e",
    strokeDasharray: "1.2 2.39"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m278.078 136.112c0-.908.644-1.618 1.638-1.618 1.295 0 1.736 1.118 1.736 2.381 0 1.532-.625 2.44-1.809 2.44-.861 0-1.394-.467-1.473-1.105h.625c.033.322.309.605.848.605.816 0 1.184-.717 1.184-1.815v-.204h-.033c-.118.572-.611.881-1.197.881-.94 0-1.519-.657-1.519-1.565zm.625-.046v.079c0 .579.335 1.046 1.019 1.046.605 0 1.02-.454 1.02-1.046v-.079c0-.559-.395-1.072-1.026-1.072-.645 0-1.013.5-1.013 1.072zm5.2 4.143h-.553l.48-1.716h.625zm2.589-4.097c0-.908.644-1.618 1.638-1.618 1.295 0 1.736 1.118 1.736 2.381 0 1.532-.625 2.44-1.809 2.44-.861 0-1.394-.467-1.473-1.105h.625c.033.322.309.605.848.605.816 0 1.184-.717 1.184-1.815v-.204h-.033c-.118.572-.611.881-1.197.881-.94 0-1.519-.657-1.519-1.565zm.625-.046v.079c0 .579.335 1.046 1.019 1.046.605 0 1.02-.454 1.02-1.046v-.079c0-.559-.395-1.072-1.026-1.072-.645 0-1.013.5-1.013 1.072zm3.582.046c0-.908.644-1.618 1.638-1.618 1.295 0 1.736 1.118 1.736 2.381 0 1.532-.625 2.44-1.809 2.44-.861 0-1.394-.467-1.473-1.105h.625c.033.322.309.605.848.605.816 0 1.184-.717 1.184-1.815v-.204h-.033c-.118.572-.611.881-1.197.881-.94 0-1.519-.657-1.519-1.565zm.625-.046v.079c0 .579.335 1.046 1.019 1.046.605 0 1.02-.454 1.02-1.046v-.079c0-.559-.395-1.072-1.026-1.072-.645 0-1.013.5-1.013 1.072zm4.121 3.157 2.177-4.104h-2.657v-.526h3.308v.513l-2.17 4.117zm5.391.059c-.263 0-.46-.204-.46-.46 0-.263.197-.467.46-.467s.461.204.461.467c0 .256-.198.46-.461.46zm4.207-4.788c1.046 0 1.684.697 1.684 1.828v1.151c0 1.158-.645 1.842-1.684 1.842-1.032 0-1.684-.684-1.684-1.842v-1.151c0-1.131.645-1.828 1.684-1.828zm0 4.275c.671 0 1.066-.493 1.066-1.296v-1.144c0-.789-.395-1.289-1.066-1.289s-1.065.5-1.065 1.289v1.144c0 .803.394 1.296 1.065 1.296zm4.207-4.275c1.046 0 1.684.697 1.684 1.828v1.151c0 1.158-.645 1.842-1.684 1.842-1.032 0-1.684-.684-1.684-1.842v-1.151c0-1.131.645-1.828 1.684-1.828zm0 4.275c.671 0 1.066-.493 1.066-1.296v-1.144c0-.789-.395-1.289-1.066-1.289s-1.065.5-1.065 1.289v1.144c0 .803.394 1.296 1.065 1.296z",
    fill: "#8a919e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.078 94.2578c0-.9076.644-1.6179 1.638-1.6179 1.295 0 1.736 1.1181 1.736 2.3809 0 1.5324-.625 2.4401-1.809 2.4401-.861 0-1.394-.467-1.473-1.105h.625c.033.3223.309.6051.848.6051.816 0 1.184-.7169 1.184-1.8153v-.2039h-.033c-.118.5722-.611.8814-1.197.8814-.94 0-1.519-.6577-1.519-1.5654zm.625-.046v.0789c0 .5788.335 1.0458 1.019 1.0458.605 0 1.02-.4539 1.02-1.0458v-.0789c0-.5591-.395-1.0721-1.026-1.0721-.645 0-1.013.4999-1.013 1.0721zm5.2 4.1435h-.553l.48-1.7166h.625zm2.589-4.0975c0-.9076.644-1.6179 1.638-1.6179 1.295 0 1.736 1.1181 1.736 2.3809 0 1.5324-.625 2.4401-1.809 2.4401-.861 0-1.394-.467-1.473-1.105h.625c.033.3223.309.6051.848.6051.816 0 1.184-.7169 1.184-1.8153v-.2039h-.033c-.118.5722-.611.8814-1.197.8814-.94 0-1.519-.6577-1.519-1.5654zm.625-.046v.0789c0 .5788.335 1.0458 1.019 1.0458.605 0 1.02-.4539 1.02-1.0458v-.0789c0-.5591-.395-1.0721-1.026-1.0721-.645 0-1.013.4999-1.013 1.0721zm3.582.046c0-.9076.644-1.6179 1.638-1.6179 1.295 0 1.736 1.1181 1.736 2.3809 0 1.5324-.625 2.4401-1.809 2.4401-.861 0-1.394-.467-1.473-1.105h.625c.033.3223.309.6051.848.6051.816 0 1.184-.7169 1.184-1.8153v-.2039h-.033c-.118.5722-.611.8814-1.197.8814-.94 0-1.519-.6577-1.519-1.5654zm.625-.046v.0789c0 .5788.335 1.0458 1.019 1.0458.605 0 1.02-.4539 1.02-1.0458v-.0789c0-.5591-.395-1.0721-1.026-1.0721-.645 0-1.013.4999-1.013 1.0721zm3.582.046c0-.9076.644-1.6179 1.638-1.6179 1.295 0 1.736 1.1181 1.736 2.3809 0 1.5324-.625 2.4401-1.809 2.4401-.861 0-1.394-.467-1.473-1.105h.625c.033.3223.309.6051.848.6051.816 0 1.184-.7169 1.184-1.8153v-.2039h-.033c-.118.5722-.611.8814-1.197.8814-.94 0-1.519-.6577-1.519-1.5654zm.625-.046v.0789c0 .5788.335 1.0458 1.019 1.0458.605 0 1.02-.4539 1.02-1.0458v-.0789c0-.5591-.395-1.0721-1.026-1.0721-.645 0-1.013.4999-1.013 1.0721zm5.305 3.2162c-.263 0-.46-.2039-.46-.4604 0-.2631.197-.467.46-.467s.461.2039.461.467c0 .2565-.198.4604-.461.4604zm4.207-4.7881c1.046 0 1.684.6971 1.684 1.8284v1.151c0 1.1575-.645 1.8416-1.684 1.8416-1.032 0-1.684-.6841-1.684-1.8416v-1.151c0-1.1313.645-1.8284 1.684-1.8284zm0 4.2751c.671 0 1.066-.4933 1.066-1.2957v-1.1444c0-.7893-.395-1.2892-1.066-1.2892s-1.065.4999-1.065 1.2892v1.1444c0 .8024.394 1.2957 1.065 1.2957zm4.207-4.2751c1.046 0 1.684.6971 1.684 1.8284v1.151c0 1.1575-.645 1.8416-1.684 1.8416-1.032 0-1.684-.6841-1.684-1.8416v-1.151c0-1.1313.645-1.8284 1.684-1.8284zm0 4.2751c.671 0 1.066-.4933 1.066-1.2957v-1.1444c0-.7893-.395-1.2892-1.066-1.2892s-1.065.4999-1.065 1.2892v1.1444c0 .8024.394 1.2957 1.065 1.2957z",
    fill: "#8a919e"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00d17f",
    height: 11.7833,
    rx: 1.19583,
    width: 42.7833,
    x: 273.167,
    y: 67.6479
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.34 75.0397v-.5196h1.263v-2.7953h-1.138v-.513h1.138v-.8024h.618v4.1107h1.23v.5196zm5.667-4.729c1.046 0 1.684.6972 1.684 1.8285v1.151c0 1.1575-.645 1.8416-1.684 1.8416-1.033 0-1.684-.6841-1.684-1.8416v-1.151c0-1.1313.645-1.8285 1.684-1.8285zm0 4.2752c.671 0 1.066-.4933 1.066-1.2957v-1.1444c0-.7893-.395-1.2892-1.066-1.2892s-1.065.4999-1.065 1.2892v1.1444c0 .8024.394 1.2957 1.065 1.2957zm4.102 1.4403h-.553l.481-1.7166h.624zm4.312-5.7155c1.046 0 1.684.6972 1.684 1.8285v1.151c0 1.1575-.645 1.8416-1.684 1.8416-1.032 0-1.684-.6841-1.684-1.8416v-1.151c0-1.1313.645-1.8285 1.684-1.8285zm0 4.2752c.671 0 1.066-.4933 1.066-1.2957v-1.1444c0-.7893-.395-1.2892-1.066-1.2892s-1.065.4999-1.065 1.2892v1.1444c0 .8024.394 1.2957 1.065 1.2957zm4.207-4.2752c1.046 0 1.684.6972 1.684 1.8285v1.151c0 1.1575-.645 1.8416-1.684 1.8416-1.032 0-1.684-.6841-1.684-1.8416v-1.151c0-1.1313.645-1.8285 1.684-1.8285zm0 4.2752c.671 0 1.066-.4933 1.066-1.2957v-1.1444c0-.7893-.395-1.2892-1.066-1.2892s-1.065.4999-1.065 1.2892v1.1444c0 .8024.394 1.2957 1.065 1.2957zm4.207-4.2752c1.046 0 1.684.6972 1.684 1.8285v1.151c0 1.1575-.645 1.8416-1.684 1.8416-1.032 0-1.684-.6841-1.684-1.8416v-1.151c0-1.1313.645-1.8285 1.684-1.8285zm0 4.2752c.671 0 1.066-.4933 1.066-1.2957v-1.1444c0-.7893-.395-1.2892-1.066-1.2892s-1.065.4999-1.065 1.2892v1.1444c0 .8024.394 1.2957 1.065 1.2957zm4.207.513c-.263 0-.46-.2039-.46-.4604 0-.2631.197-.467.46-.467s.461.2039.461.467c0 .2565-.198.4604-.461.4604zm4.207-4.7882c1.046 0 1.684.6972 1.684 1.8285v1.151c0 1.1575-.645 1.8416-1.684 1.8416-1.032 0-1.684-.6841-1.684-1.8416v-1.151c0-1.1313.645-1.8285 1.684-1.8285zm0 4.2752c.671 0 1.066-.4933 1.066-1.2957v-1.1444c0-.7893-.395-1.2892-1.066-1.2892s-1.065.4999-1.065 1.2892v1.1444c0 .8024.394 1.2957 1.065 1.2957zm4.207-4.2752c1.046 0 1.684.6972 1.684 1.8285v1.151c0 1.1575-.645 1.8416-1.684 1.8416-1.032 0-1.683-.6841-1.683-1.8416v-1.151c0-1.1313.644-1.8285 1.683-1.8285zm0 4.2752c.671 0 1.066-.4933 1.066-1.2957v-1.1444c0-.7893-.395-1.2892-1.066-1.2892s-1.065.4999-1.065 1.2892v1.1444c0 .8024.394 1.2957 1.065 1.2957z",
    fill: "#0a0b0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.948 53.7208v-.5196h1.263v-2.7952h-1.138v-.513h1.138v-.8024h.618v4.1106h1.23v.5196zm5.667-4.7289c1.046 0 1.684.6972 1.684 1.8284v1.151c0 1.1576-.644 1.8416-1.684 1.8416-1.032 0-1.683-.684-1.683-1.8416v-1.151c0-1.1312.644-1.8284 1.683-1.8284zm0 4.2751c.671 0 1.066-.4933 1.066-1.2957v-1.1444c0-.7892-.395-1.2891-1.066-1.2891-.67 0-1.065.4999-1.065 1.2891v1.1444c0 .8024.395 1.2957 1.065 1.2957zm4.102 1.4404h-.552l.48-1.7166h.625zm4.313-5.7155c1.045 0 1.683.6972 1.683 1.8284v1.151c0 1.1576-.644 1.8416-1.683 1.8416-1.033 0-1.684-.684-1.684-1.8416v-1.151c0-1.1312.644-1.8284 1.684-1.8284zm0 4.2751c.67 0 1.065-.4933 1.065-1.2957v-1.1444c0-.7892-.395-1.2891-1.065-1.2891-.671 0-1.066.4999-1.066 1.2891v1.1444c0 .8024.395 1.2957 1.066 1.2957zm4.207-4.2751c1.045 0 1.683.6972 1.683 1.8284v1.151c0 1.1576-.644 1.8416-1.683 1.8416-1.033 0-1.684-.684-1.684-1.8416v-1.151c0-1.1312.644-1.8284 1.684-1.8284zm0 4.2751c.67 0 1.065-.4933 1.065-1.2957v-1.1444c0-.7892-.395-1.2891-1.065-1.2891-.671 0-1.066.4999-1.066 1.2891v1.1444c0 .8024.395 1.2957 1.066 1.2957zm2.746.4538v-.5196h1.263v-2.7952h-1.138v-.513h1.138v-.8024h.619v4.1106h1.229v.5196zm5.668.0592c-.263 0-.461-.2039-.461-.4604 0-.2631.198-.4669.461-.4669s.46.2038.46.4669c0 .2565-.197.4604-.46.4604zm4.207-4.7881c1.045 0 1.683.6972 1.683 1.8284v1.151c0 1.1576-.644 1.8416-1.683 1.8416-1.033 0-1.684-.684-1.684-1.8416v-1.151c0-1.1312.644-1.8284 1.684-1.8284zm0 4.2751c.67 0 1.065-.4933 1.065-1.2957v-1.1444c0-.7892-.395-1.2891-1.065-1.2891-.671 0-1.066.4999-1.066 1.2891v1.1444c0 .8024.395 1.2957 1.066 1.2957zm4.207-4.2751c1.045 0 1.683.6972 1.683 1.8284v1.151c0 1.1576-.644 1.8416-1.683 1.8416-1.033 0-1.684-.684-1.684-1.8416v-1.151c0-1.1312.644-1.8284 1.684-1.8284zm0 4.2751c.671 0 1.065-.4933 1.065-1.2957v-1.1444c0-.7892-.394-1.2891-1.065-1.2891s-1.066.4999-1.066 1.2891v1.1444c0 .8024.395 1.2957 1.066 1.2957z",
    fill: "#8a919e"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#27ad75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.2628 78.3184v24.4676",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.9679 81.2107v20.3703",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.125 80.247v17.2374",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.288 95.9126v20.6114",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.452 94.7075v17.2375",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.53 92.2975v17.2375",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.071 82.4157v24.2273",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.609 58.5552v36.2777",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.15 66.7496v7.8377",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.318 70.1239v24.7089",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.859 61.447v28.3242",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 14.8272,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67319,
    x: 189.441,
    y: 94.7075
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 14.8272,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67317,
    x: 124.034,
    y: 82.6572
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 14.5862,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67319,
    x: 176.362,
    y: 97.3588
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 14.5862,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67319,
    x: 195.981,
    y: 88.2002
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 15.0683,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67317,
    x: 65.173,
    y: 84.3435
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 14.8272,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67317,
    x: 235.228,
    y: 76.3906
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 24.9499,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67319,
    x: 202.518,
    y: 69.8828
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 24.95,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67317,
    x: 241.761,
    y: 64.8213
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 3.25838,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67319,
    x: 209.064,
    y: 69.1598
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 11.453,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67319,
    x: 97.8771,
    y: 83.3798
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 11.453,
    rx: 0.298958,
    strokeWidth: 0.597917,
    width: 2.67319,
    x: 150.201,
    y: 98.0817
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 12.2919,
    rx: 0.597917,
    width: 3.2711,
    x: 110.656,
    y: 88.1423
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 12.5329,
    rx: 0.597917,
    width: 3.2711,
    x: 162.981,
    y: 102.844
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 12.2919,
    rx: 0.597917,
    width: 3.2711,
    x: 182.6,
    y: 101.881
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 11.8099,
    rx: 0.597917,
    width: 3.2711,
    x: 117.201,
    y: 90.0701
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 12.2919,
    rx: 0.597917,
    width: 3.2711,
    x: 169.521,
    y: 104.531
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 12.2919,
    rx: 0.597917,
    width: 3.27109,
    x: 45.2539,
    y: 77.7783
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 12.5329,
    rx: 0.597917,
    width: 3.2711,
    x: 215.311,
    y: 69.5839
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 7.47155,
    rx: 0.597917,
    width: 3.2711,
    x: 51.792,
    y: 86.2142
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 7.47156,
    rx: 0.597917,
    width: 3.27112,
    x: 221.847,
    y: 78.0194
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 7.23055,
    rx: 0.597917,
    width: 3.27109,
    x: 58.3359,
    y: 92.9626
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 7.47155,
    rx: 0.597917,
    width: 3.2711,
    x: 228.391,
    y: 84.5269
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 10.1227,
    rx: 0.597917,
    width: 3.2711,
    x: 77.9551,
    y: 73.6815
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 9.88177,
    rx: 0.597917,
    width: 3.27109,
    x: 248.011,
    y: 82.1167
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 10.3637,
    rx: 0.597917,
    width: 3.2711,
    x: 130.275,
    y: 88.1423
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 3.37424,
    rx: 0.597917,
    width: 3.27109,
    x: 84.4883,
    y: 84.0447
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 3.37423,
    rx: 0.597917,
    width: 3.27109,
    x: 254.548,
    y: 92.2394
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 2.8922,
    rx: 0.597917,
    width: 3.2711,
    x: 136.821,
    y: 98.9883
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 8.4356,
    rx: 0.597917,
    width: 3.27108,
    x: 91.0381,
    y: 86.6963
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 8.1946,
    rx: 0.597917,
    width: 3.27109,
    x: 261.085,
    y: 94.8907
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 8.67665,
    rx: 0.597917,
    width: 3.2711,
    x: 143.354,
    y: 101.157
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 10.1227,
    rx: 0.597917,
    width: 3.2711,
    x: 104.112,
    y: 83.0808
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0616d",
    height: 10.1228,
    rx: 0.597917,
    width: 3.2711,
    x: 156.443,
    y: 97.7827
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.3488 64.8213v21.5757",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.4 72.7754v21.8167",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.669 79.2824v21.5756",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.8781 79.2824v12.417",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.937 87.2361v12.6581",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.21 93.9845v12.1765",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.4191 81.6928v20.3702",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.478 89.8872v20.3708",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.747 96.395v20.371",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.501 83.3798v24.4682",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.837 98.0817v24.4683",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.046 84.1028v24.7092",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.361 98.8049v24.4681",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.989 102.661v14.104",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.591 90.6102v14.1038",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.911 105.312v13.863",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.6427 78.3184v14.3452",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.694 70.1239v14.1041",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.1808 80.4872v14.1041",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.243 72.2931v14.1041",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.7296 93.2616v13.8634",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.768 84.8258v14.1042",
    stroke: "#f0616d",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m40.5255 69.4006v28.5653",
    stroke: "#098551",
    strokeLinecap: "round",
    strokeWidth: 0.597917
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a0b0d",
    height: 25.191,
    rx: 0.298958,
    stroke: "#098551",
    strokeWidth: 0.597917,
    width: 1.82863,
    x: 39.716,
    y: 72.7754
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseExchange);
export default __webpack_public_path__ + "static/media/CoinbaseExchange.c811c9703253dd5101344504417a1ac3.svg";
export { ForwardRef as ReactComponent };